import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppHelper } from "../appHelper/appHelper"
import { TServiceResult } from "../Infra/TServiceResult"
import { MARITALSTATUSES } from "../data/marital-status"
import { DOCUMENTTYPES } from "../data/document-type"
import { INSURANCETYPES } from "../data/insurance-type"
import { BASICINFORMATIONTYPE } from "../data/basic-information-type"
import { REMOVETYPES } from "../data/remove-type"

import { MaritalStatus } from "../../Models/marital-status";
import { DocumentType } from "../../Models/document-type";
import { InsuranceType } from "../../Models/insurance-type";
import { RemoveType } from "../../Models/remove-type";
import { BasicInformationType } from "../../Models/basic-information-type";


@Injectable()
export class BaseDataGuard implements CanActivate {
  baseUrl = AppHelper.BaseUrl;
  httpOptions: {};
  
  constructor(private http: HttpClient) {
  }
  async canActivate() {
    if (!BASICINFORMATIONTYPE[0]) {
      var bi = await this.getBasicInformationTypes();
      for (let item of bi.returnValue) {
        if (item.basicInformationTypeId!=3)//آسیب های اجتماعی حذف شد
        BASICINFORMATIONTYPE.push(item)
      }
    }

    if (!MARITALSTATUSES[0]) {
      var ms = await this.getMaritalStatuses();
      for (let item of ms.returnValue) {
        MARITALSTATUSES.push(item)
      }
    }
    if (!DOCUMENTTYPES[0]) {
      var doc = await this.getDocumentTypes();
      for (let item of doc.returnValue) {
        DOCUMENTTYPES.push(item)
      }
    }
    if (!INSURANCETYPES[0]) {
      var it = await this.getInsuranceTypes();
      for (let item of it.returnValue) {
        INSURANCETYPES.push(item)
      }
    }

    if (!REMOVETYPES[0]) {
      var rt = await this.getRemoveTypes();
      for (let item of rt.returnValue) {
        REMOVETYPES.push(item)
      }
    }
    return true;



  }

  getBasicInformationTypes(): Promise<TServiceResult<BasicInformationType[]>> {
    return this.http.get<TServiceResult<BasicInformationType[]>>(this.baseUrl + 'BasicInformationType/GetAll', this.httpOptions).toPromise();
  }

  getMaritalStatuses(): Promise<TServiceResult<MaritalStatus[]>> {
    return this.http.get<TServiceResult<MaritalStatus[]>>(this.baseUrl + 'MaritalStatus/GetAll', this.httpOptions).toPromise();
  }
  getDocumentTypes(): Promise<TServiceResult<DocumentType[]>> {
    return this.http.get<TServiceResult<DocumentType[]>>(this.baseUrl + 'Document/GetDocumentTypes', this.httpOptions).toPromise();
  }
  getInsuranceTypes(): Promise<TServiceResult<InsuranceType[]>> {
    return this.http.get<TServiceResult<InsuranceType[]>>(this.baseUrl + 'InsuranceType/GetAll', this.httpOptions).toPromise();
  }
  getRemoveTypes(): Promise<TServiceResult<RemoveType[]>> {
    return this.http.get<TServiceResult<RemoveType[]>>(this.baseUrl + 'Family/GetRemoveTypeByTableName', this.httpOptions).toPromise();
  }

}
